import moment from 'moment/moment';
import {ORDER, ORDER_SOURCE, ORDER_STATUS} from 'helpers/constants/orders_v2';

const getCurrentLocationTime = (timezone) =>
  moment()
    .utc()
    .utcOffset(Number(timezone) || 0)
    .format();

export const checkIsFutureOrder = (order) => {
  return (
    order[ORDER.AHEAD_TIME] &&
    moment(`${order[ORDER.EXPIRED_TIME]}Z`).utcOffset(0).format() >
      getCurrentLocationTime(order?.Timezone)
  );
};

export const checkIsRefundOrder = (_order) => {
  const order = {..._order};

  return Array.isArray(order[ORDER.REFUND]) && order[ORDER.REFUND].length > 0;
};

export const checkIsFullNotToSauceRefundOrder = (_order) => {
  const order = {..._order};
  return (
    Array.isArray(order[ORDER.REFUND]) &&
    !!order[ORDER.REFUND]?.find((item) => item.type === 'Full')
  );
};

export const checkIsPossibleToCancelDriver = (order) => {
  return (
    moment(`${order[ORDER.DATE]}Z`).utc().utcOffset(0).format() >
      getCurrentLocationTime(order?.Timezone) &&
    order[ORDER.SOURCE] === ORDER_SOURCE.SAUCE
  );
};

export const checkIsFullRefundOrder = (order) => {
  return (
    !!order[ORDER.REFUND] &&
    !!order[ORDER.REFUND]?.find((item) => item.type === 'Full')
  );
};

export const formattedOrderForBaD = (order) => {
  return {
    userEmail: order[ORDER.CUSTOMER]?.email,
    userName: order[ORDER.CUSTOMER]?.fullName,
    userPhone: order[ORDER.CUSTOMER]?.phone,
    orderInfo: {
      total: order[ORDER.TOTALS]?.locationTotal,
      items: order[ORDER.CART]?.items,
      alcoholTax: order[ORDER.TAXES]?.alcoholTaxAmount,
      deliveryAddress: order[ORDER.DELIVERY]?.address?.formattedAddress,
      deliveryAddressDecode: {
        Address: {
          Number: order[ORDER.DELIVERY]?.address?.number,
          Street: order[ORDER.DELIVERY]?.address?.street,
          City: order[ORDER.DELIVERY]?.address?.city,
          State: order[ORDER.DELIVERY]?.address?.state,
          ZipCode: order[ORDER.DELIVERY]?.address?.zipCode
        },
        Сoordinates: {
          Latitude: order[ORDER.DELIVERY]?.address?.latitude,
          Longitude: order[ORDER.DELIVERY]?.address?.longitude
        }
      },
      deliveryAddressDetails: {
        Notes: order[ORDER.DELIVERY]?.address?.notes,
        Apt: order[ORDER.DELIVERY]?.address?.apt,
        Entrance: order[ORDER.DELIVERY]?.address?.entrance,
        Floor: order[ORDER.DELIVERY]?.address?.floor
      }
    },
    invoiceID: order[ORDER.INVOICE_ID],
    id: order[ORDER.OLD_ORDER_ID],
    orderStatus: order[ORDER.ORDER_STATUS],
    date: order[ORDER.DATE]
  };
};

export const calculateOverdueAndFuture = (order) => {
  // eslint-disable-next-line prefer-const
  let {internalOrderStatus, overdueDisabled, Timezone} = order;

  if (
    [ORDER_STATUS.NEW, ORDER_STATUS.ACCEPTED].includes(internalOrderStatus) ||
    !internalOrderStatus
  ) {
    const currentOrderTime = moment(`${order[ORDER.DATE]}Z`)
      .utcOffset(0)
      .format();

    if (
      getCurrentLocationTime(Timezone) > currentOrderTime &&
      !overdueDisabled
    ) {
      internalOrderStatus = ORDER_STATUS.OVERDUE;
    }
    if (
      checkIsFutureOrder(order) &&
      order[ORDER.ORDER_STATUS] !== ORDER_STATUS.ACCEPTED
    ) {
      internalOrderStatus = ORDER_STATUS.FUTURE;
    }
  }

  return {...order, internalOrderStatus};
};
